var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-light-primary font-weight-bolder mr-2",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ki ki-long-arrow-back icon-xs"}),_vm._v(_vm._s(_vm.$t("BACK"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }